import axios from "axios";
import StorageHelper from "@/helpers/storage";

export default {
  getInstance({ api = "/api" } = { api: "/api" }) {
    const contentType = "application/json;charset=UTF-8";
    const headers = {
      "Content-Type": contentType,
      "Access-Control-Allow-Origin": "*",
      "access-control-allow-origin": "*",
      "Access-Control-Allow-Headers": "*",
    };

    const tokens = StorageHelper.loadState("tokens");
    if (tokens) {
      headers.Authorization = `Bearer ${tokens.accessToken}`;
    }

    return axios.create({
      baseURL: api,
      timeout: 30000,
      headers,
      maxContentLength: 20 * 1000000,
    });
  },
  create({ baseURL, timeout, maxContentLength }) {
    const contentType = "application/json;charset=UTF-8";
    const headers = {
      "Content-Type": contentType,
      "Access-Control-Allow-Origin": "*",
      "access-control-allow-origin": "*",
      "Access-Control-Allow-Headers": "*",
    };

    const tokens = StorageHelper.loadState("tokens");
    if (tokens) {
      headers.Authorization = `Bearer ${tokens.accessToken}`;
    }

    return axios.create({
      baseURL,
      timeout: timeout || 30000,
      headers,
      maxContentLength: maxContentLength || 20 * 1000000,
    });
  },
};
